<template>
  <div class="ah-active-filters">
    <active-filter
      v-for="(filter, i) in filters"
      :key="`active-filter-${i}`"
      :removeFilterAccessibleLabel="removeFilterAccessibleLabel"
      :handleFilterRemove="() => handleFilterRemove(filter)"
      :filter="filter"
    />
    <div v-if="count > 0">
      <div
        class="ah-clear-filters"
        @click="handleClearFilters"
      >
        <img
          class="ah-clear-filters-icon"
          :src="clearFiltersIconSrc"
          aria-hidden="true"
        />
        <span
          class="ah-clear-filters-label"
        >
          {{ clearFiltersLabel }}   
        </span>  
      </div>
    </div>
  </div>
</template>

<script>
  import ActiveFilter from './ActiveFilter.vue'

  import { store, getters, mutations } from '../../data/store'

  export default {
    name: 'active-filters',
    props: {
      clearFiltersLabel: String,
      removeFilterAccessibleLabel: String,
      //handleClearFilters: Function,
    },
    data() {
      return {
        clearFiltersIconSrc: '../../../../../Static/icons/AH/x.svg'
      }
    },
    computed: {
      activeFilters: function() {
        return getters.activeFilters() || []
      },
      filters: function() {
        const filters = this.activeFilters
        const query = getters.activeQuery()
        if (query.length > 0) filters.push(query[0])
        return filters
      },
      count: function() {
        return getters.activeFilters().length + getters.activeQuery().length
      },
    },
    methods: {
      handleClearFilters: function() {
        mutations.clearFilters()
      }
    },
    components: {
      ActiveFilter,
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../scss/_variablesAH.scss";

  .ah-active-filters {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    margin: -4px;
  }
  .ah-clear-filters {
    margin: 7px 0 7px 20px;
    font-family: $font-main;
    font-size: 16px;
    color: $ah-blue;
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .ah-clear-filters-label {
    margin-left: 6px;
  }
</style>